import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import ModalProps from '../../../interfaces/ModalProps';

interface ConfirmationModaltWithTriggerProps extends ModalProps {
  callTrigger: () => void;
  handleClose: () => void;
  headerText: string;
  alertText: string;
  buttonText1: string;
  buttonText2: string;
}

const ConfirmationModaltWithTrigger = ({
  open,
  callTrigger,
  handleClose,
  headerText,
  alertText,
  buttonText1 = 'OK',
  buttonText2 = 'Cancel',
}: ConfirmationModaltWithTriggerProps) => {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '604px',
        },
      }}
    >
      <DialogTitle
        sx={{
          paddingX: '24px',
          paddingTop: '24px',
          paddingBottom: '16px',
        }}
      >
        {headerText}
      </DialogTitle>
      <DialogContent>
        <Typography color='#4F4F4F'>{alertText}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          padding: '24px',
        }}
      >
        <Button
          variant='outlined'
          color='inherit'
          sx={{
            textTransform: 'none',
            color: 'black',
            height: '42px',
            borderColor: '#D1D1D1',
            borderWidth: '1px',
          }}
          onClick={handleClose}
        >
          {buttonText1}
        </Button>
        <Button
          variant='contained'
          color='blue'
          sx={{
            textTransform: 'none',
            height: '42px',
          }}
          disableElevation
          onClick={callTrigger}
        >
          <Typography fontSize={14} fontWeight={600}>
            {buttonText2}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModaltWithTrigger;